<template>
  <div class="quiz-container">
    <!-- خلفية زخرفية متحركة خفيفة -->
    <div class="bg-orbs" aria-hidden="true">
      <span class="orb orb-a"></span>
      <span class="orb orb-b"></span>
      <span class="orb orb-c"></span>
    </div>

    <!-- الهيدر -->
    <header class="header">
      <h1 class="title" aria-label="Bacly Plus">
        🎓 MQBank<span class="plus">+</span>
      </h1>
    </header>

    <!-- الأزرار -->
    <nav class="buttons" aria-label="خيارات سريعة">

      <button
        @click="$emit('select','D'); logEventToTelegram('اختبار القيد بدرجة دكتوراه')"
        class="main-btn btn-bank"
        type="button"
      >
        <span class="icon" aria-hidden="true">📚</span>
        <span class="label">اختبار القيد بدرجة دكتوراه</span>
      </button>

      <button
        @click="$emit('select','M'); logEventToTelegram('اختبار اللغة الانكليزية للقيد في درجة ماجستير')"
        class="main-btn btn-bank"
        type="button"
      >
        <span class="icon" aria-hidden="true">📚</span>
        <span class="label">اختبار اللغة الانكليزية للقيد في درجة ماجستير</span>
      </button>

      <button
        @click="$emit('select','B'); logEventToTelegram('اختبار القيد بدرجة ماجستير - افتراضي')"
        class="main-btn btn-bank"
        type="button"
      >
        <span class="icon" aria-hidden="true">📚</span>
        <span class="label">اختبار القيد بدرجة ماجستير - افتراضي</span>
      </button>

      <button
        @click="$emit('select','T'); logEventToTelegram('تحديد المستوى PT - افتراضي')"
        class="main-btn btn-bank"
        type="button"
      >
        <span class="icon" aria-hidden="true">📚</span>
        <span class="label">تحديد المستوى (PT) - افتراضي</span>
      </button>

      <button
        @click="$emit('select','w'); logEventToTelegram('اختبار وطني للغات - تعليم عالي')"
        class="main-btn btn-bank"
        type="button"
      >
        <span class="icon" aria-hidden="true">📚</span>
        <span class="label">اختبار وطني للغات - تعليم عالي</span>
      </button>

      <a
        href="https://t.me/qeyd_master_english"
        target="_blank"
        rel="noopener"
        class="main-btn btn-telegram"
        aria-label="قناة التلغرام"
        @click="logEventToTelegram('زيارة قناة التلغرام')"
      >
        <span class="icon icon-telegram" aria-hidden="true" role="img">
          <svg
            viewBox="0 0 240 240"
            width="22"
            height="22"
            xmlns="http://www.w3.org/2000/svg"
            focusable="false"
          >
            <defs>
              <linearGradient id="tgGrad" x1="0" x2="1" y1="0" y2="1">
                <stop offset="0%" stop-color="#2AABEE" />
                <stop offset="100%" stop-color="#229ED9" />
              </linearGradient>
            </defs>
            <circle cx="120" cy="120" r="120" fill="url(#tgGrad)" />
            <path
              d="M179 75.4c2.2-1.1 4.6 1.1 3.8 3.4l-25.8 121.4c-.7 3.2-4.5 4.5-7 2.5l-35.3-26.6a5 5 0 0 1-1.8-3.2l-2.9-23.6a5 5 0 0 1 1.5-4.3l58.6-55.4c1.4-1.3-.3-3.6-1.9-2.6l-72.2 45.6a5 5 0 0 1-4.6.3l-31.1-14a3 3 0 0 1 .2-5.5l117.5-48.1z"
              fill="#fff"
            />
          </svg>
        </span>
        <span class="label">قناة التلغرام الرسمية</span>
      </a>

      <router-link
        to="/resources"
        class="main-btn btn-resources"
        aria-label="اسئلة دورات محلولة"
        @click="logEventToTelegram('زيارة صفحة قواعد اللغة')"
      >
        <span class="icon" aria-hidden="true">🧭</span>
        <span class="label">قواعد اللغة الانكليزية</span>
      </router-link>
    </nav>

    <!-- فوتر صغير -->
    <footer class="footer">
      <span class="badge">Made with ♥ for Students</span>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'BranchSelector',
  methods: {
    async logEventToTelegram(eventName) {
      const BOT_TOKEN = '8441222744:AAEn9UToghHSEZ-2ETIONsngRJNz0JD1-Ck';
      const CHAT_ID = '8011339494';
      const message = `📌 <b>حدث جديد</b>\n\n🧪 <b>الحدث:</b> ${eventName}\n🕒 <b>الوقت:</b> ${new Date().toLocaleString()}`;

      try {
        await fetch(`https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            chat_id: CHAT_ID,
            text: message,
            parse_mode: 'HTML'
          })
        });
      } catch (error) {
        console.error('فشل إرسال الحدث إلى تيليغرام:', error);
      }
    }
  }
}
</script>


<style scoped>
/* =========================
   خلفية أفخم + عمق أعلى
========================= */
.quiz-container{
  position: relative;
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
  padding: 3.2rem 1.25rem 2.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.75rem;
  text-align: center;
  color: #eef0f7;

  background:
    radial-gradient(1200px 800px at 12% 12%, rgba(99,102,241,.20), transparent 55%),
    radial-gradient(900px 600px at 88% 18%, rgba(34,211,238,.16), transparent 55%),
    radial-gradient(900px 700px at 55% 92%, rgba(167,139,250,.14), transparent 60%),
    linear-gradient(180deg, #06060d 0%, #0b0d14 55%, #06060d 100%);
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Tajawal", "Inter", system-ui, sans-serif;
}

/* طبقة “فيلم” + حبيبات خفيفة تعطي فخامة */
.quiz-container::before{
  content:"";
  position:absolute;
  inset:0;
  background:
    radial-gradient(1200px 900px at 50% 0%, rgba(255,255,255,.06), transparent 45%),
    linear-gradient(180deg, rgba(255,255,255,.05), transparent 28%, rgba(0,0,0,.25));
  opacity: .7;
  pointer-events:none;
}
.quiz-container::after{
  content:"";
  position:absolute;
  inset:0;
  background-image:
    repeating-linear-gradient(0deg, rgba(255,255,255,.03) 0 1px, transparent 1px 3px);
  opacity: .06; /* حبيبات خفيفة جداً */
  mix-blend-mode: overlay;
  pointer-events:none;
}

/* زخارف */
.bg-orbs{ position:absolute; inset:0; pointer-events:none; filter: blur(48px); opacity:.95; }
.orb{
  position:absolute; width: 300px; height: 300px; border-radius: 50%;
  opacity:.35; mix-blend-mode: screen;
  animation: float 12s ease-in-out infinite;
}
.orb-a{ background:#3b82f6; top:10%; left:6%; animation-delay:0s; }
.orb-b{ background:#22d3ee; bottom:14%; right:8%; animation-delay:3s; }
.orb-c{ background:#a78bfa; top:56%; left:64%; animation-delay:6s; }
@keyframes float{
  0%,100%{ transform: translateY(0) translateX(0) scale(1); }
  50%{ transform: translateY(-16px) translateX(10px) scale(1.04); }
}

/* =========================
   العناوين
========================= */
.header{
  display:flex;
  flex-direction:column;
  align-items:center;
  gap:.75rem;
  z-index:1;
}
.title{
  margin:0;
  font-weight: 950;
  letter-spacing: -0.03em;
  font-size: clamp(2.25rem, 6vw, 3.7rem);
  line-height: 1.05;

  background: linear-gradient(90deg, #fff2c2 0%, #ffcf4a 35%, #ffb300 55%, #fff0b3 100%);
  -webkit-background-clip:text;
  background-clip:text;
  color: transparent;

  text-shadow:
    0 0 18px rgba(255,206,72,.12),
    0 10px 40px rgba(0,0,0,.35);
}
.title .plus{
  background: linear-gradient(90deg, #b7f7cc, #22c55e);
  -webkit-background-clip:text;
  background-clip:text;
  color: transparent;
}
.subtitle{
  margin: 0 0 .6rem 0;
  font-size: clamp(.95rem, 3vw, 1.05rem);
  line-height: 1.8;
  font-weight: 850;
  letter-spacing: .15px;

  background: linear-gradient(180deg, #fff7df 0%, #d4af37 42%, #b8860b 72%, #7a5c1e 100%);
  -webkit-background-clip:text;
  background-clip:text;
  color: transparent;

  text-shadow:
    0 2px 3px rgba(0,0,0,.65),
    0 -1px 1px rgba(255,255,255,.16);
}

/* =========================
   الأزرار: فاخر + احتواء تلقائي
   - محتوى الزر يحدد عرضه (fit-content)
   - مع حد أقصى ليتناسب على الجوال
========================= */
.buttons{
  z-index:1;
  display:flex;
  flex-direction:column;
  align-items:center;      /* لأن الأزرار الآن بعرض تلقائي */
  gap: 1rem;
  width: 100%;
}

/* الزر نفسه */
.main-btn{
  appearance:none;
  border: 1px solid rgba(255,255,255,.14);
  border-radius: 999px;

  /* احتواء تلقائي للمحتوى */
  width: fit-content;
  max-width: min(92vw, 520px); /* لا يتجاوز شاشة الجوال */
  min-width: 220px;           /* يعطي حضور وفخامة */
  box-sizing: border-box;

  padding: 1.05rem 1.35rem;   /* “فخم” بدون مبالغة */
  display:inline-flex;
  align-items:center;
  justify-content:center;
  gap: .75rem;

  /* لو النص طويل: يلف بشكل جميل داخل الزر */
  white-space: normal;
  text-align: center;
  line-height: 1.15;

  font-weight: 850;
  font-size: 1.05rem;
  letter-spacing: .2px;
  color: #f6f7ff;
  text-decoration:none;
  cursor:pointer;
  position:relative;
  overflow:hidden;

  /* زجاج فاخر + لمعة ذهبية دقيقة */
  background:
    radial-gradient(140% 120% at 18% 0%, rgba(255,255,255,.16), rgba(255,255,255,.05) 55%, rgba(255,255,255,.02) 100%),
    linear-gradient(180deg, rgba(255,255,255,.06), rgba(255,255,255,.01));

  backdrop-filter: blur(12px) saturate(150%);
  -webkit-backdrop-filter: blur(12px) saturate(150%);

  box-shadow:
    0 26px 70px rgba(0,0,0,.58),
    0 10px 22px rgba(0,0,0,.40),
    inset 0 1px 0 rgba(255,255,255,.18);

  transition:
    transform .18s ease,
    box-shadow .25s ease,
    border-color .25s ease,
    filter .25s ease;
}

/* إطار متدرّج فاخر (بدون تشويه المحتوى) */
.main-btn::after{
  content:"";
  position:absolute;
  inset:0;
  padding: 1px;
  border-radius: 999px;
  background: linear-gradient(90deg,
    rgba(255,255,255,.16),
    rgba(255,210,90,.18),
    rgba(120,180,255,.16),
    rgba(255,255,255,.12)
  );
  -webkit-mask:
    linear-gradient(#000 0 0) content-box,
    linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events:none;
  opacity:.9;
}

/* لمعة تمرّ عند الهوفر */
.main-btn::before{
  content:"";
  position:absolute;
  inset:-2px;
  background: linear-gradient(110deg,
    transparent 0%,
    rgba(255,255,255,.22) 22%,
    rgba(255,255,255,.10) 30%,
    transparent 48%
  );
  transform: translateX(-70%);
  opacity: .55;
  transition: transform .75s ease, opacity .25s ease;
  pointer-events:none;
}
.main-btn:hover::before{ transform: translateX(70%); opacity:.7; }

.main-btn:hover{
  transform: translateY(-2px);
  border-color: rgba(255,255,255,.20);
  filter: saturate(1.05);
  box-shadow:
    0 34px 92px rgba(0,0,0,.62),
    0 14px 28px rgba(0,0,0,.44),
    inset 0 1px 0 rgba(255,255,255,.20);
}
.main-btn:active{ transform: translateY(0); }

/* تركيز لوحة مفاتيح */
.main-btn:focus-visible{
  outline:none;
  box-shadow:
    0 0 0 4px rgba(99,102,241,.50),
    0 26px 70px rgba(0,0,0,.58),
    inset 0 1px 0 rgba(255,255,255,.18);
}

/* أيقونة + نص */
.icon{
  font-size: 1.25em;
  display:inline-flex;
  align-items:center;
  justify-content:center;
}
.label{ display:inline-block; }

/* =========================
   تنويعات فخمة
========================= */
.btn-bank{
  background:
    radial-gradient(140% 120% at 18% 0%, rgba(147,197,253,.20), rgba(255,255,255,.05) 55%, rgba(255,255,255,.02) 100%),
    linear-gradient(180deg, rgba(255,255,255,.06), rgba(255,255,255,.01));
}

.btn-telegram{
  color:#fff;
  background:
    radial-gradient(140% 120% at 18% 0%, rgba(255,255,255,.18), rgba(255,255,255,.06) 55%, rgba(255,255,255,.02) 100%),
    linear-gradient(135deg, #2AABEE, #229ED9);
  box-shadow:
    0 28px 76px rgba(34,158,217,.32),
    0 10px 22px rgba(0,0,0,.40),
    inset 0 1px 0 rgba(255,255,255,.18);
}
.btn-telegram:hover{
  background:
    radial-gradient(140% 120% at 18% 0%, rgba(255,255,255,.22), rgba(255,255,255,.07) 55%, rgba(255,255,255,.02) 100%),
    linear-gradient(135deg, #3ac2fb, #2aa6e0);
}

.btn-resources{
  color:#ffe9a8;
  background:
    radial-gradient(140% 120% at 18% 0%, rgba(255,224,138,.20), rgba(255,255,255,.05) 55%, rgba(255,255,255,.02) 100%),
    linear-gradient(180deg, rgba(255,255,255,.06), rgba(255,255,255,.01));
}

/* =========================
   فوتر
========================= */
.footer{ z-index:1; }
.badge{
  display:inline-block;
  font-size: .82rem;
  color:#aab3c3;
  background: rgba(255,255,255,.04);
  border: 1px solid rgba(255,255,255,.10);
  padding: .48rem .9rem;
  border-radius: 999px;
  backdrop-filter: blur(10px);
}

/* شاشات ضيقة */
@media (max-width: 360px){
  .main-btn{
    min-width: 200px;
    font-size: 1rem;
    padding: .98rem 1.1rem;
  }
}
</style>